// @ts-nocheck
// Auto-migrated from js/mockData.js
// ---------- 包体（Packages） ----------
const PACKAGES = [
  {
    id: "p_a1b2c3d4e5f6",
    game_id: "g_001",
    name: "王者征途 US iOS 正式包",
    region: "US",
    region_name: "United States / 美国",
    platform: "iOS",
    bundle_id: "com.kingsquest.ios",
    store_url: "https://apps.apple.com/app/kingsquest",
    config_status: "configured",
    today_share: 3214,
    today_install: 245,
  },
  {
    id: "p_g7h8i9j0k1l2",
    game_id: "g_001",
    name: "王者征途 US Google Play 正式包",
    region: "US",
    region_name: "United States / 美国",
    platform: "Google Play",
    bundle_id: "com.kingsquest.android",
    store_url: "https://play.google.com/store/apps/details?id=com.kingsquest.android",
    config_status: "configured",
    today_share: 2890,
    today_install: 198,
  },
  {
    id: "p_m3n4o5p6q7r8",
    game_id: "g_001",
    name: "王者征途 UK iOS 正式包",
    region: "GB",
    region_name: "United Kingdom / 英国",
    platform: "iOS",
    bundle_id: "com.kingsquest.ios",
    store_url: "https://apps.apple.com/app/kingsquest",
    config_status: "inherited",
    today_share: 1056,
    today_install: 89,
  },
  {
    id: "p_s9t0u1v2w3x4",
    game_id: "g_001",
    name: "王者征途 SG Google Play 正式包",
    region: "SG",
    region_name: "Singapore / 新加坡",
    platform: "Google Play",
    bundle_id: "com.kingsquest.android",
    store_url: "https://play.google.com/store/apps/details?id=com.kingsquest.android",
    config_status: "configured",
    today_share: 856,
    today_install: 64,
  },
  {
    id: "p_y5z6a7b8c9d0",
    game_id: "g_001",
    name: "王者征途 JP iOS 测试包",
    region: "JP",
    region_name: "Japan / 日本",
    platform: "iOS",
    bundle_id: "com.kingsquest.ios.jp",
    store_url: "https://apps.apple.com/jp/app/kingsquest",
    config_status: "draft",
    today_share: 218,
    today_install: 16,
  },
  {
    id: "p_e1f2g3h4i5j6",
    game_id: "g_002",
    name: "梦幻西游 US iOS 正式包",
    region: "US",
    region_name: "United States / 美国",
    platform: "iOS",
    bundle_id: "com.fantasywest.ios",
    store_url: "https://apps.apple.com/app/fantasywest",
    config_status: "configured",
    today_share: 2890,
    today_install: 187,
  },
  {
    id: "p_k7l8m9n0o1p2",
    game_id: "g_002",
    name: "梦幻西游 US Google Play 正式包",
    region: "US",
    region_name: "United States / 美国",
    platform: "Google Play",
    bundle_id: "com.fantasywest.android",
    store_url: "https://play.google.com/store/apps/details?id=com.fantasywest",
    config_status: "configured",
    today_share: 2456,
    today_install: 165,
  },
  {
    id: "p_q3r4s5t6u7v8",
    game_id: "g_002",
    name: "梦幻西游 TW iOS 本地化包",
    region: "TW",
    region_name: "Taiwan / 台湾",
    platform: "iOS",
    bundle_id: "com.fantasywest.ios.tw",
    store_url: "https://apps.apple.com/tw/app/fantasywest",
    config_status: "configured",
    today_share: 666,
    today_install: 93,
  },
];

export { PACKAGES };
